// Production
export const FN_Backend = 'https://prod-fnbackend.talent500.co/';
export const FN_Backend_API = `${FN_Backend}fastnext/`;
export const Talent_Backend = 'https://prod-warmachine.talent500.co/';

// Development
// export const FN_Backend = 'https://fastnext-bn-development.talent500.co/';
// export const FN_Backend_API = `${FN_Backend}fastnext/`;
// export const Talent_Backend = 'https://preprod-warmachine.talent500.co/';

//  Preprod
// export const FN_Backend = 'https://fastnext-bn-preprod.talent500.co/';
// export const FN_Backend_API = `${FN_Backend}fastnext/`;
// export const Talent_Backend = 'https://preprod-warmachine.talent500.co/';
